import type { TaxonomyKind, TaxonomyOption } from "./courseMeta";
import { COURSE_DIALOG_STYLE, taxonomyKindLabel } from "./courseMeta";
import TaxonomyPicker from "./TaxonomyPicker";
import "./CourseMetaFields.css";

export type { TaxonomyKind, TaxonomyOption };
export { COURSE_DIALOG_STYLE, taxonomyKindLabel };

export function CourseMetaFields({
  title,
  description,
  taxonomyId,
  taxonomyOptions,
  taxonomyLoading,
  saving,
  titleId = "course-title",
  descriptionId = "course-desc",
  onTitle,
  onDescription,
  onTaxonomy,
  onTaxonomyOptions,
  onPickerOpenChange,
  taxonomyListOpen,
  onTaxonomyListOpenChange,
  autoFocusTitle = true,
}: {
  title: string;
  description: string;
  taxonomyId: string;
  taxonomyOptions: TaxonomyOption[];
  taxonomyLoading: boolean;
  saving: boolean;
  titleId?: string;
  descriptionId?: string;
  onTitle: (value: string) => void;
  onDescription: (value: string) => void;
  onTaxonomy: (id: string) => void;
  onTaxonomyOptions?: (options: TaxonomyOption[]) => void;
  /** Lets a hosting dialog suppress its own overlay/Escape close while the entry editor is up. */
  onPickerOpenChange?: (open: boolean) => void;
  taxonomyListOpen?: boolean;
  onTaxonomyListOpenChange?: (open: boolean) => void;
  autoFocusTitle?: boolean;
}) {
  return (
    <>
      <label className="al-courses-label" htmlFor={titleId}>
        Title
      </label>
      <input
        id={titleId}
        data-tour="cb-title"
        className="al-courses-input"
        value={title}
        onChange={(event) => onTitle(event.target.value)}
        placeholder="e.g. Algebra I"
        required
        disabled={saving}
        autoFocus={autoFocusTitle}
      />
      <label className="al-courses-label" htmlFor={descriptionId}>
        Description
      </label>
      <textarea
        id={descriptionId}
        data-tour="cb-description"
        className="al-courses-textarea"
        value={description}
        onChange={(event) => onDescription(event.target.value)}
        placeholder="Optional — what this course covers"
        rows={3}
        disabled={saving}
      />

      <div className="al-courses-tax" data-tour="cb-category">
        <span className="al-courses-label">Primary category</span>
        <TaxonomyPicker
          selectedId={taxonomyId}
          options={taxonomyOptions}
          loading={taxonomyLoading}
          disabled={saving}
          onSelect={onTaxonomy}
          onOptionsChange={onTaxonomyOptions}
          onEditorOpenChange={onPickerOpenChange}
          listOpen={taxonomyListOpen}
          onListOpenChange={onTaxonomyListOpenChange}
        />
      </div>
    </>
  );
}
